import { getKeycloakInstance } from "@/lib/auth/keycloak";

export async function authenticatedFetch(url: string, options: RequestInit = {}) {
  const keycloak = getKeycloakInstance();

  // Refresh token if it expires within 30 seconds
  await keycloak.updateToken(30);

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${keycloak.token}`,
    },
  });
}
